export const TABS = {
  COMMENTS: 'comments',
  TASKS: 'tasks',
  CALENDAR: 'calendar',
  CAMPAIGNS: 'campaigns',
  APPROVALS: 'approvals'
};